import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarIcon } from '@factorialco/f0-react'
import { Search } from '@factorialco/f0-react/icons/app'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { getIndustryDisplayName } from 'modules/marketplace_modules/lib/mappingMarketplace'

interface SimilarCompaniesProps {
  benefit: string
  module: string
  moduleName: string
}

const SimilarCompanies: React.FC<SimilarCompaniesProps> = ({ benefit, moduleName }) => {
  const { company } = useCurrentSession()
  const mainLegalEntity = company?.legalEntities?.find((entity) => entity.main)
  const country = mainLegalEntity?.country || 'other'
  const industryDisplayName = getIndustryDisplayName(company?.industry || undefined)

  const getCompaniesLikeText = () => {
    if (country === 'es') {
      return i18n.t('marketplace.revamp.companies_like.es')
    }
    if (country === 'fr') {
      return i18n.t('marketplace.revamp.companies_like.fr')
    }
    if (country === 'de') {
      return i18n.t('marketplace.revamp.companies_like.de')
    }
    if (country === 'it') {
      return i18n.t('marketplace.revamp.companies_like.it')
    }
    return i18n.t('marketplace.revamp.companies_like.other')
  }

  if (!moduleName || !benefit || !company?.industry) return null

  return (
    <Box flexDirection="column" gap="s20">
      <Text size="200" weight="medium">
        <span className="text-f1-foreground-secondary">
          {i18n.t('marketplace.revamp.for_companies_like_yours')}
        </span>
      </Text>
      <Box
        padding="s2"
        flexDirection="column"
        borderRadius={{ all: 'abs016' }}
        style={{ backgroundColor: '#051F510A' }}
      >
        <Box flexDirection="row" alignItems="center">
          <Box flexDirection="row" gap="s8" alignItems="flexStart" padding="s8">
            <F0AvatarIcon icon={Search} size="sm" />
            <Text size="200">
              {getCompaniesLikeText()}{' '}
              <span style={{ fontWeight: 600 }}>{industryDisplayName}</span> {benefit}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default SimilarCompanies
